import { GenderEnum, User } from './user.model';
import { Sport } from '../sports/sport.model';
import { QuestionTypeSportResponse } from '../sports/question-type-sport-response.model';
import { Subsidiary } from './subsidiary.model';
import { TwoListsSelectModel } from '../../components/two-lists-select/two-lists-select.model';
import { TestCenter } from '../test-center.model';
import { SalomonContract } from '../salomon-contract.model';

export class Athlete extends TwoListsSelectModel {
  public userId: number | null;
  public userFirstName: string = '';
  public userLastName: string = '';
  public userLogin: string;
  public userReferent: string;
  public address: string;
  public codePostal: string;
  public ville: string;
  public pays: string;
  public fis_code: string;
  public mobile: string;
  public birthdate: Date;
  public team: string;
  public gender: GenderEnum;
  public sports: Sport[] = [];
  public sportsResponses: QuestionTypeSportResponse[];
  public subsidiary: Subsidiary;
  public testCenter: TestCenter | null = null;
  public salomonContract: SalomonContract | null = null;
  public isEld: boolean = false;
  public selected: boolean; // front only
  private _user: User;

  // Morphology
  public height: number | null = null;
  public weight: number | null = null;
  //Upper body morphology
  public armLength: number | null;
  public chestPerimeter: number | null;
  public waistPerimeter: number | null;
  public hipPerimeter: number | null;
  public shirtSize: number;
  public headSize: number | null;
  // Lower body morphology-
  public legLength: number | null;
  public maximalThighPerimeter: number | null;
  public maximalCalfPerimeter: number | null;
  public pantsSize: string;
  public shoesSize: number | null;
  //Right foot morphology
  public rightFootInstepHeight: number | null;
  public rightFootCalfPerimeterAt15: number | null;
  public rightFootCalfPerimeterAt25: number | null;
  public rightFootLength: number | null;
  public rightFootMetaWidth: number | null;
  public rightFootInStepPerimeter: number | null;
  public rightFrontPerimeter: number | null;
  public rightParisPoint: number | null;
  public rightMondopointLength: number | null;
  // Left foot morphology
  public leftFootInstepHeight: number | null;
  public leftFootCalfPerimeterAt15: number | null;
  public leftFootCalfPerimeterAt25: number | null;
  public leftFootLength: number | null;
  public leftFootMetaWidth: number | null;
  public leftFootInStepPerimeter: number | null;
  public leftFrontPerimeter: number | null;
  public leftParisPoint: number | null;
  public leftMondopointLength: number | null;

  get user() {
    return this._user;
  }

  set user(user: User) {
    this._user = Object.assign(new User(), user);
    this.userId = user.id;
    this.userFirstName = user.firstName;
    this.userLastName = user.lastName;
    this.userLogin = user.login;
    if (user.sponsor) this.userReferent = user.sponsor;
  }

  override get title(): string {
    return this.userFirstName + ' ' + this.userLastName;
  }
}
